<div class="container text-left">
  <mat-toolbar class="titulo">Outros</mat-toolbar>
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" tipoOrdem="OUTROS"></app-nro-processo-input>
        </div>
      </div>

      <div class="form-dados-ordem">

        <h3 class="subtitulo">Prazo de atendimento</h3>
        <div class="form-group">
          <mat-radio-group [color]="'primary'" formControlName="nroSla">
            <mat-radio-button [value]="120">5 dias</mat-radio-button>
            <mat-radio-button [value]="72">3 dias</mat-radio-button>
            <mat-radio-button [value]="48">2 dias</mat-radio-button>
            <mat-radio-button [value]="24">1 dia</mat-radio-button>
          </mat-radio-group>
        </div>

        <h3 class="subtitulo">Titulares</h3>
        <div formGroupName="titular">
          <div class="form-row ">
            <div class="col-7">
              <mat-form-field appearance="outline" class="inputs">
                <mat-label>Nome</mat-label>
                <input
                  matInput
                  placeholder="Nome"
                  formControlName="nome"
                  maxlength="55"
                  noSpecialChars
                />
                <mat-hint align="end">{{nome.value?.length}} / 55</mat-hint>
                <mat-error *ngIf="nome.hasError('required')">
                  Nome completo é <strong>obrigat&oacute;rio</strong>
                </mat-error>
                <mat-error *ngIf="nome.hasError('valueOnlyNumberError')">
                  Nome do titular não pode conter apenas números
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="outline" class="inputs">
                <mat-label>CPF/CNPJ</mat-label>
                <input
                  matInput
                  type='text'
                  mask="000.000.000-00||00.000.000/0000-00"
                  placeholder="CPF/CNPJ"
                  formControlName="nroDocumento"

                />
                <mat-error *ngIf="nroDocumento.hasError('required')">
                  CPF/CNPJ é <strong>obrigat&oacute;rio</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-center align-items-center col-auto ">
              <button
                mat-button
                type="button"
                class="btn btn-branco"
                (click)="addTitular(nome.value, nroDocumento.value)"
                [disabled]="disableAddDevedor()"
              >
                Adicionar
              </button>
            </div>
          </div>
        </div>

        <table mat-table class="mat-elevation-z2" [dataSource]="titulares" *ngIf="titulares.length > 0">
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let titular"> {{titular.nome}} </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumento">
            <th mat-header-cell *matHeaderCellDef> Documento </th>
            <td mat-cell *matCellDef="let titular">
              {{ titular.documento | mask: isPessoaFisica(titular.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Ações </th>
            <td mat-cell *matCellDef="let titular">
              <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
                <mat-icon  class="table-icon">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="after">
                <button (click)="removerTitular(titular)" mat-menu-item>
                  <mat-icon class="table-icon">close</mat-icon>
                  <span>Excluir</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="form-row">
          <div class="info-message">
            <mat-icon class="info-icon" fontIcon="info"></mat-icon>
            <p>
              Se houver mais titulares, adicionar nesse momento!
            </p>
          </div>
        </div>

        <h3 class="subtitulo">Dados para inclusão</h3>
        <div class="form-row align-items-center">
          <div class="col-3">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Foro</mat-label>
              <mat-select
                formControlName="foro"
                (selectionChange)="onChangeForo($event.value)"
                placeholder="Foro"
              >
                <mat-option *ngFor="let foro of foros" [value]="foro">
                  {{ foro.descricaoForo }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="showSpinnerForo" align="end"
                ><span class="float-left align-baseline">carregando foros </span>
                <mat-spinner class="float-lg-right" [diameter]="20"></mat-spinner>
              </mat-hint>
              <mat-error *ngIf="foro.hasError('required')">
                Foro é <strong>obrigat&oacute;rio</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Vara</mat-label>
              <mat-select
                formControlName="vara"
                (selectionChange)="onChangeVara($event.value)"
                placeholder="Vara"
              >
                <mat-option *ngFor="let vara of varas" [value]="vara">
                  {{ vara.descricaoVara }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="showSpinnerVara" align="end"
                ><span class="float-left align-baseline">carregando varas </span>
                <mat-spinner class="float-lg-right" [diameter]="20"></mat-spinner>
              </mat-hint>
              <mat-error *ngIf="vara.hasError('required')">
                Vara é <strong>obrigat&oacute;rio</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Comarca</mat-label>
              <input
                matInput
                placeholder="Comarca"
                formControlName="comarca"
              />
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>UF</mat-label>
              <input
                matInput
                placeholder="UF"
                formControlName="uf"
              />
            </mat-form-field>
          </div>
        </div>

        <h3 class="subtitulo">Anexo</h3>
        <div class="div-add-documento">
          <div class="file-info" *ngIf="!arquivoAnexo">
            <button type="button" mat-raised-button (click)="fileInput.click()">
              <mat-icon>computer</mat-icon> Selecionar do computador
            </button>
            <input type="file" accept=".pdf" #fileInput (change)="fileBrowseHandler($event)"/>
          </div>
          <div class="file-info" *ngIf="arquivoAnexo">
            <p><strong>Arquivo anexado:</strong> {{ arquivoAnexo.name }}</p>
            <button type="button" class="remover-anexo" mat-raised-button (click)="removeFile()">Remover</button>
          </div>
        </div>

        <div class="form-row ordem-textarea">
          <div class="col-12">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Descrição da Ordem</mat-label>
              <textarea
                matInput
                [placeholder]="MENSAGEM_DESCRICAO"
                formControlName="descricaoOrdem"
                maxlength="400"
                minlength="60"
                rows="6"
              >
              </textarea>
              <mat-hint align="end">{{ descricaoOrdem.value?.length }} / 400</mat-hint>
              <mat-error *ngIf="descricaoOrdem.touched && descricaoOrdem.hasError('required')">
                Descrição da ordem é <strong>obrigatória</strong>
              </mat-error>
              <mat-error *ngIf="descricaoOrdem.hasError('minlength')">
                Descrição da ordem deve conter <strong>no mínimo 60 caracteres</strong>. {{ descricaoOrdem.value?.length }} / 400
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row ">
          <div class="col-sm-7"></div>
          <div class="col-sm-5">
            <div class="form-row">
              <div class="form-group col-md-6">
                <button
                  mat-raised-button
                  (click)="handleEnviarOrdem()"
                  [disabled]="disableForm()"
                  class="btn btn-azul btn-block"
                >
                  Enviar
                </button>
              </div>
              <div class="form-group col-md-6">
                <button
                  mat-raised-button
                  (click)="cancelar()"
                  class="btn btn-branco btn-block"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
